import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import myTheme from '../../themes/myTheme';

export const redesignMuiTheme = createMuiTheme(myTheme, {
  overrides: {
    MuiButton: {
      label: {
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        textTransform: 'inherit',
        letterSpacing: 'inherit',
      },
    },
  },
});
